import { Link } from "react-router-dom";
import {
  HOME_URL_LOCAL,
  ORDERS_URL_LOCAL,
  SHOPPINGCART_URL_LOCAL,
} from "../../utility/BaseUrl";

export default function SectionUser() {
  return (
    <>
      <div>
        <div>
          <div className="pagetitle ">
            <ol className="breadcrumb">
              <li>
                <Link to={HOME_URL_LOCAL}> خانه </Link>
              </li>
              <li className="active font-weight-bold"> میزکار </li>
            </ol>
          </div>
          <div className="content-wrapper no-sidebar user-dashboard ">
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-12"></div>
                <div className="col-sm-12">
                  <div className="status-box">
                    <div className="w-restricted-lg center-block">
                      <div className="container-pn">
                        <div className="row status-items">
                          <div className="col-xs-12 col-sm-4">
                            <div className="status-items status-items-item">
                              <Link to={ORDERS_URL_LOCAL}>
                                <div>
                                  <p
                                    style={{
                                      fontSize: 44,
                                      color: "rgb(102, 150, 242)",
                                      lineHeight: 1,
                                      margin: 0,
                                      height: 50,
                                      "-darkreaderInlineColor": "#65aaf2",
                                    }}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="1em"
                                      height="1em"
                                      fill="currentColor"
                                      class="bi bi-list-check"
                                      viewBox="0 0 16 16"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        d="M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3.854 2.146a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708L2 3.293l1.146-1.147a.5.5 0 0 1 .708 0zm0 4a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708L2 7.293l1.146-1.147a.5.5 0 0 1 .708 0zm0 4a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 0 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0z"
                                      ></path>
                                    </svg>
                                  </p>
                                  <p className="status-items-subtitle">
                                    لیست سفارش‌ها
                                  </p>
                                </div>
                                <h5 className="status-items-title">
                                  1 <small> فاکتور </small>
                                </h5>
                              </Link>
                            </div>
                          </div>
                          {/* <div className="col-xs-12 col-sm-4">
                                <div className="status-items status-items-item">
                                <div>
                                    <p
                                    style={{
                                        fontSize: 40,
                                        color: "rgb(102, 150, 242)",
                                        lineHeight: 1,
                                        margin: 0,
                                        height: 50,
                                        "-darkreaderInlineColor": "#65aaf2",
                                    }}
                                    >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="1em"
                                        height="1em"
                                        fill="currentColor"
                                        className="bi bi-cash-stack"
                                        viewBox="0 0 16 16"
                                        style={{
                                        "-darkreaderInlineFill": "currentColor",
                                        }}
                                    >
                                        <path d="M1 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1H1zm7 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
                                        <path d="M0 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V5zm3 0a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V7a2 2 0 0 1-2-2H3z" />
                                    </svg>
                                    </p>
                                    <p className="status-items-subtitle">
                                    پرداخت‌های شما
                                    </p>
                                </div>
                                <h5 className="status-items-title">
                                    0 <small>تومان</small>
                                </h5>
                                </div>
                            </div> */}
                          <div className="col-xs-12 col-sm-4">
                            <div className="status-items status-items-item">
                              <Link to={SHOPPINGCART_URL_LOCAL}>
                                <div>
                                  <p
                                    style={{
                                      fontSize: 44,
                                      color: "rgb(102, 150, 242)",
                                      lineHeight: 1,
                                      margin: 0,
                                      height: 50,
                                      "-darkreaderInlineColor": "#65aaf2",
                                    }}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="1em"
                                      height="1em"
                                      fill="currentColor"
                                      class="bi bi-bag"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1m3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4zM2 5h12v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z" />
                                    </svg>
                                  </p>
                                  <p className="status-items-subtitle">
                                    سبد خرید
                                  </p>
                                </div>
                                <h5 className="status-items-title">
                                  1 <small> سفارش </small>
                                </h5>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
